import { LoadingSpinner } from '@mesa-labs/mesa-ui';
import React from 'react';
import styled from 'styled-components';

import { useGetVendorStatusSummaryByIdQuery } from '../../../../redux/api/vendors';
import { StepsCard, VendorStatusCard } from '../../EnablementV2VendorStatus';
import { Muted } from './styles';

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// The Vendor's Enablement steps and statuses, as the Enablement expanded row shows them.
export default function VendorSummary({ vendorId }: { vendorId: string }): React.ReactElement {
  const { currentData: summary, isFetching } = useGetVendorStatusSummaryByIdQuery({ vendorId });

  if (!summary) return isFetching ? <LoadingSpinner height="18px" /> : <Muted>No Enablement summary for this vendor</Muted>;
  return (
    <Cards>
      <StepsCard steps={summary.steps} />
      <VendorStatusCard row={summary} />
    </Cards>
  );
}
